import { defineComponent as y, useSlots as g, openBlock as e, createElementBlock as s, createElementVNode as c, unref as i, createBlock as p, withCtx as a, renderSlot as r, createCommentVNode as o, createVNode as l, createTextVNode as v, toDisplayString as m, normalizeClass as k } from "vue";
import S from "./ghl-ui.es171.js";
import "./ghl-ui.es20.js";
import "./ghl-ui.es35.js";
import "./ghl-ui.es5.js";
import "./ghl-ui.es358.js";
import b from "./ghl-ui.es180.js";
import w from "./ghl-ui.es120.js";
import $ from "./ghl-ui.es74.js";
import I from "./ghl-ui.es71.js";
import U from "./ghl-ui.es124.js";
const B = { class: "hl-statistic" }, C = { class: "hl-statistic-header" }, T = {
  key: 0,
  class: "hl-statistic-action"
}, G = { class: "hl-content" }, N = { class: "hl-container" }, V = {
  key: 0,
  class: "trend trend-container"
}, _ = { key: 1 }, q = { key: 0 }, D = { key: 0 }, A = {
  key: 0,
  class: "badge badge--positive"
}, E = { key: 1 }, z = {
  key: 0,
  class: "badge badge--negative"
}, F = { key: 1 }, M = y({
  name: "UIStatistic",
  inheritAttrs: !1
}), j = y({
  ...M,
  props: {
    id: {
      type: String,
      required: !0
    },
    icon: {
      type: Function
    },
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "success"
    },
    trendTitle: {
      type: String,
      default: ""
    },
    showGraph: {
      type: Boolean,
      default: !1,
      required: !1
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  emits: ["select"],
  setup(t) {
    const n = g();
    return (d, u) => {
      var h;
      return e(), s("div", B, [
        c("div", C, [
          c("div", null, [
            (h = i(n)) != null && h.icon ? (e(), p(i(b), {
              key: 0,
              type: "success"
            }, {
              default: a(() => [
                r(d.$slots, "icon")
              ]),
              _: 3
            })) : o("", !0),
            l(i(w), { class: "title" }, {
              default: a(() => [
                v(m(t.title), 1)
              ]),
              _: 1
            })
          ]),
          t.options.length ? (e(), s("div", T, [
            l(i($), {
              options: t.options,
              onSelect: u[0] || (u[0] = (f) => d.$emit("select", f)),
              id: `${t.id}-dropdown`
            }, {
              default: a(() => [
                l(i(I), {
                  circle: "",
                  quaternary: "",
                  id: `${t.id}-dropdown-trigger`
                }, {
                  default: a(() => [
                    l(i(S), { class: "w-5 h-5" })
                  ]),
                  _: 1
                }, 8, ["id"])
              ]),
              _: 1
            }, 8, ["options", "id"])
          ])) : o("", !0)
        ]),
        c("div", G, [
          c("div", N, [
            l(i(U), null, {
              default: a(() => [
                r(d.$slots, "default")
              ]),
              _: 3
            }),
            t.showGraph ? (e(), s("div", V, [
              i(n).badge ? (e(), s("div", {
                key: 0,
                class: k({
                  "trend trend--success": t.type === "success",
                  "trend trend--error": t.type === "error"
                })
              }, [
                r(d.$slots, "badge")
              ], 2)) : o("", !0),
              t.trendTitle ? (e(), s("div", _, m(t.trendTitle), 1)) : o("", !0)
            ])) : o("", !0)
          ]),
          t.showGraph ? o("", !0) : (e(), s("div", q, [
            t.type === "success" ? (e(), s("div", D, [
              i(n).badge ? (e(), s("div", A, [
                r(d.$slots, "badge")
              ])) : o("", !0)
            ])) : o("", !0),
            t.type === "error" ? (e(), s("div", E, [
              i(n).badge ? (e(), s("div", z, [
                r(d.$slots, "badge")
              ])) : o("", !0)
            ])) : o("", !0)
          ])),
          t.showGraph && i(n).graph ? (e(), s("div", F, [
            r(d.$slots, "graph")
          ])) : o("", !0)
        ])
      ]);
    };
  }
}), Z = j;
export {
  Z as default
};
